export const DELETE_SAFETY_WORD: string = 'delete'
